(function() {

  // 'gespart' nur auf DE, englischer Shop (onnihair.com) bekommt 'saved' (21.07.2026)
  const ONNI_IS_EN = (document.documentElement.lang || 'de').toLowerCase().indexOf('en') === 0;
  const ONNI_SAVED = ONNI_IS_EN ? 'saved' : 'gespart';
  const ONNI_PRICEINFO = ONNI_IS_EN ? 'Price info' : 'Preisinfo';

  /* ONNI 06.08.2026 (Paavo): Rabattprozente werden IMMER abgerundet. Aus 54,75
     wird 54, nie 55 — es soll nie mehr versprochen werden, als der Kunde bekommt.
     Gilt einheitlich fuer den Hero und die Badges auf den Produktkacheln, sonst
     stehen auf derselben Seite zwei verschiedene Zahlen.
     Das toFixed(6) davor faengt Fliesskomma-Reste ab: 1 − 0,7 ergibt in
     JavaScript 30,000000000000004, andere Rechnungen landen knapp DARUNTER bei
     29,999999999999996 — ohne die Bereinigung waere daraus eine 29 geworden. */
  function onniProzentAb(wert) {
    if (!isFinite(wert)) return 0;
    return Math.floor(Number(wert.toFixed(6)));
  }

  /* ONNI 06.08.2026 (Paavo): Preistext -> Zahl, deutsches Format.
     Der alte Weg war `parseFloat('20,90')` — parseFloat bricht am Komma ab und
     liefert 20. Bei glatten Preisen wie 179,00 faellt das nicht auf, bei allen
     anderen war der VIP-Preis auf der Kachel zu niedrig, der Checkout verlangte
     also mehr als angezeigt.
     Reihenfolge zaehlt: erst alles ausser Ziffern, Punkt und Komma weg, dann
     der Tausenderpunkt (nur wenn danach ein Komma folgt, sonst wuerde aus einem
     englisch formatierten '1.5' die 15), dann Komma zu Punkt. */
  function onniPreisZuZahl(text) {
    if (text === null || text === undefined) return NaN;
    var s = String(text).replace(/[^\d.,-]/g, '');
    if (s.indexOf(',') > -1) { s = s.replace(/\./g, ''); }
    s = s.replace(',', '.');
    return parseFloat(s);
  }

  // Grundpreis auf den Code-Preis umrechnen: die erste Zahl im Text mit dem Faktor
  // Code-Preis / Listenpreis malnehmen, Einheit und Waehrung bleiben stehen.
  function onniGrundpreisUmrechnen(html, faktor) {
    if (!isFinite(faktor) || faktor <= 0) return html;
    return String(html).replace(/\d{1,3}(?:\.\d{3})*,\d{2}|\d+\.\d{2}/, function (m) {
      var n = onniPreisZuZahl(m) * faktor;
      return isFinite(n) ? ONNI_PREIS.euro(n) : m;
    });
  }

  /* Code-Review A-08 (Johannes 28.10.2026): die EINE Preis- und Rabattrechnung im Theme-JS.
     Alles, was einen Code-Preis, einen Rabattprozentsatz oder einen Euro-Betrag ausgibt,
     rechnet hierueber: die Code-Preise unten (Karte, PDP, Varianten-Kacheln, Set-Preisinfo,
     Hero „BIS −x %") und das Set-Badge in onni-set-price.js (window.ONNI_PREIS, discount.js
     laeuft vorher). Das Liquid-Gegenstueck fuer Prozentwerte ist snippets/onni-rabatt-prozent.liquid.
     Rechnung bewusst unveraendert gegenueber vorher (Fliesskomma wie bisher, A-09 Cent-Rechnung
     waere eine sichtbare Aenderung und ist ein eigener Schritt). */
  var ONNI_PREIS = {
    zahl: onniPreisZuZahl,
    // 12.5 -> '12,50'
    euro: function (n) { return n.toFixed(2).replace('.', ','); },
    // Eintrag aus discounts ({dis} / {fixed}) oder discountmix ({percoff} / {moneyoff}) -> {prozent} / {euro}
    rabatt: function (e) {
      if (e.percoff) { return {prozent: e.percoff}; }
      if (e.moneyoff) { return {euro: e.moneyoff}; }
      if (e.hasOwnProperty('fixed')) { return {euro: e.fixed}; }
      return {prozent: e.dis};
    },
    // Code-Preis aus Listenpreis (Euro) und Rabatt
    codePreis: function (preis, rabatt) {
      return rabatt.euro !== undefined ? preis - rabatt.euro : preis / 100 * (100 - rabatt.prozent);
    },
    // Ersparnis von alt auf neu in Prozent, immer abgerundet (Paavo 06.08.2026);
    // stufe > 1 rundet weiter auf glatte Stufen ab (Birthday-Sets 5er, Paavo 10.10.2026)
    prozent: function (alt, neu, stufe) {
      var p = onniProzentAb((1 - neu / alt) * 100);
      return stufe > 1 ? Math.floor(p / stufe) * stufe : p;
    },
    /* Kaufmaennisch gerundet: nur noch das Set-Badge ohne Code (onni-set-price.js) und das
       Set-Prozent im Preisinfo-Fenster (price.liquid) rechnen so, Vorbefund F15. Ob die beiden
       auch abrunden sollen, ist eine sichtbare Aenderung und braucht eine Entscheidung. */
    prozentRund: function (alt, neu) { return Math.round((1 - neu / alt) * 100); }
  };
  window.ONNI_PREIS = ONNI_PREIS;

  // see price.liquid for data attribute
  // https://onni.de/discount/matts2026

  const discountmix = [];

  discountmix['matts2026'] = [
    {cat: 'codemix-matts2026-01-einzelprodukte', moneyoff: 10},
    {cat: 'codemix-matts2026-02-sets', percoff: 10},
    {cat: 'codemix-matts2026-03-testersets', moneyoff: 17}
  ];

  const discounts = [];

  // DISCOUNT CODE = COLLECTION, RABATT 
  
  // Stand 29.07.2026: aufgeraeumte Endfassung von Paavo (Dawn-Team-Aufraeumung).
  // Reihenfolge = gewachsen, aelteste oben. NICHT alphabetisch sortieren.
  // Neue Codes IMMER unten ans Ende anhaengen.
  discounts['annette20'] = {cat: 'code', dis: 20};
  discounts['julia20'] = {cat: 'code', dis: 20};
  discounts['tina20'] = {cat: 'code', dis: 20};
  discounts['svenja20'] = {cat: 'code', dis: 20};
  discounts['mama20'] = {cat: 'mama20', dis: 20};
  discounts['christin20'] = {cat: 'code', dis: 20};
  discounts['sweetliving20'] = {cat: 'code', dis: 20};
  discounts['sophie20'] = {cat: 'code', dis: 20};
  discounts['maxi20'] = {cat: 'code', dis: 20};
  discounts['vip20'] = {cat: 'code', dis: 20};
  discounts['google18'] = {cat: 'code', dis: 18};
  discounts['sosue20'] = {cat: 'code', dis: 20};
  discounts['healing30'] = {cat: 'code', dis: 30};
  // patrizia20 (Johannes 20.10.2026): wie in Shopify 10 % auf Collection code ab 100 €. Vorher cat vip-code (gibt es nicht) und 20 %, der Shop zeigte gar keinen Rabatt.
  discounts['patrizia20'] = {cat: 'code', dis: 10};
  discounts['mothersfinest20'] = {cat: 'code', dis: 20};
  discounts['haarwuchs20'] = {cat: 'code', dis: 20};
  discounts['eva20'] = {cat: 'code', dis: 20};
  discounts['katerina-p20'] = {cat: 'code', dis: 20};
  discounts['franzi20'] = {cat: 'code', dis: 20};
  discounts['claudia-s20'] = {cat: 'code', dis: 20};
  discounts['alex-j20'] = {cat: 'code', dis: 20};
  discounts['nastinka20'] = {cat: 'code', dis: 20};
  discounts['sina20'] = {cat: 'code', dis: 20};
  discounts['louischen20'] = {cat: 'code', dis: 20};
  discounts['jelena20'] = {cat: 'code', dis: 20};
  discounts['lilly20'] = {cat: 'code', dis: 20};
  discounts['juli20'] = {cat: 'code', dis: 20};
  discounts['agnes20'] = {cat: 'code', dis: 20};
  discounts['vip25'] = {cat: 'vip-code-products', dis: 25};
  discounts['vip30'] = {cat: 'vip-code-products', dis: 30};
  discounts['vip40'] = {cat: 'vip-code-products', dis: 40};
  discounts['isi20'] = {cat: 'code', dis: 20};
  discounts['moai20'] = {cat: 'code', dis: 20};
  discounts['jessica20'] = {cat: 'code', dis: 20};
  discounts['testlori'] = {cat: 'code', dis: 20};
  discounts['ulrike20'] = {cat: 'code', dis: 20};
  discounts['pomponetti20'] = {cat: 'code', dis: 20};
  discounts['baaam20'] = {cat: 'code', dis: 20};
  discounts['susanne20'] = {cat: 'code', dis: 20};
  discounts['sara20'] = {cat: 'code', dis: 20};
  discounts['sophi20'] = {cat: 'code', dis: 20};
  discounts['tim20'] = {cat: 'code', dis: 20};
  discounts['shari20'] = {cat: 'code', dis: 20};
  discounts['yourday30'] = {cat: 'code-nl', dis: 30};
  discounts['ninag20'] = {cat: 'code', dis: 20};
  discounts['dahoam20'] = {cat: 'code', dis: 20};
  discounts['alexa20'] = {cat: 'code', dis: 20};
  discounts['vanessa30'] = {cat: 'code', dis: 30};
  discounts['pelican30'] = {cat: 'code', dis: 30};
  discounts['alexa30'] = {cat: 'code', dis: 30};
  discounts['claudia30'] = {cat: 'code', dis: 30};
  discounts['kristin30'] = {cat: 'code', dis: 30};
  discounts['jessi30'] = {cat: 'code', dis: 30};
  discounts['melanie30'] = {cat: 'code', dis: 30};
  discounts['martina30'] = {cat: 'code', dis: 30};
  discounts['sophi30'] = {cat: 'code', dis: 30};
  discounts['iisi30'] = {cat: 'code', dis: 30};
  discounts['nativita30'] = {cat: 'code', dis: 30};
  discounts['tegernsee20'] = {cat: 'code', dis: 20};
  discounts['sandra20'] = {cat: 'code', dis: 20};
  discounts['save30'] = {cat: 'code-save30', dis: 30};
  discounts['marlene20'] = {cat: 'code', dis: 20};
  discounts['sarah20'] = {cat: 'code', dis: 20};
  discounts['kinga20'] = {cat: 'code', dis: 20};
  discounts['gina20'] = {cat: 'code', dis: 20};
  discounts['valeska20'] = {cat: 'code', dis: 20};
  discounts['patricia20'] = {cat: 'code', dis: 20};
  discounts['mimi20'] = {cat: 'code', dis: 20};
  discounts['myself20'] = {cat: 'code', dis: 20};
  discounts['oktoberfest25'] = {cat: 'code-nl', dis: 25};
  discounts['onniwiesn25'] = {cat: 'code', dis: 25};
  discounts['valeska25'] = {cat: 'code', dis: 25};
  discounts['lori25'] = {cat: 'code', dis: 25};
  discounts['menina20'] = {cat: 'code', dis: 20};
  discounts['simone20'] = {cat: 'code', dis: 20};
  discounts['escanutells20'] = {cat: 'code', dis: 20};
  discounts['britta20'] = {cat: 'code', dis: 20};
  discounts['christine20'] = {cat: 'code', dis: 20};
  discounts['liv20'] = {cat: 'code', dis: 20};
  discounts['missmondo20'] = {cat: 'code', dis: 20};
  discounts['zweipluszwei20'] = {cat: 'code', dis: 20};
  discounts['kira20'] = {cat: 'code', dis: 20};
  discounts['pelican20'] = {cat: 'code', dis: 20};
  discounts['stefaniehelen20'] = {cat: 'code', dis: 20};
  discounts['cosima20'] = {cat: 'code', dis: 20};
  discounts['kera20'] = {cat: 'code', dis: 20};
  discounts['mamalina20'] = {cat: 'code', dis: 20};
  discounts['melli20'] = {cat: 'code', dis: 20};
  discounts['sarahfusca20'] = {cat: 'code', dis: 20};
  discounts['lindaloves20'] = {cat: 'code', dis: 20};
  discounts['laura20'] = {cat: 'code', dis: 20};
  discounts['tasdy20'] = {cat: 'code', dis: 20};
  discounts['patricia30'] = {cat: 'code', dis: 30};
  discounts['instyle20'] = {cat: 'code', dis: 20};
  discounts['claudi30'] = {cat: 'code', dis: 30};
  discounts['rike20'] = {cat: 'code', dis: 20};
  discounts['mami20'] = {cat: 'code', dis: 20};
  discounts['linda20'] = {cat: 'code', dis: 20};
  discounts['strawberry20'] = {cat: 'code', dis: 20};
  discounts['nele20'] = {cat: 'code', dis: 20};
  discounts['karen20'] = {cat: 'code', dis: 20};
  discounts['miriam20'] = {cat: 'code', dis: 20};
  discounts['birgit20'] = {cat: 'code', dis: 20};
  discounts['lilli20'] = {cat: 'code', dis: 20};
  discounts['katharina20'] = {cat: 'code', dis: 20};
  discounts['disco20'] = {cat: 'code', dis: 20};
  discounts['erhard20'] = {cat: 'code', dis: 20};
  discounts['sonja20'] = {cat: 'code', dis: 20};
  discounts['nini20'] = {cat: 'code', dis: 20};
  discounts['savexxl'] = {cat: 'vip-code-savexxl', dis: 30};
  discounts['romina20'] = {cat: 'code', dis: 20};
  discounts['katrin-u20'] = {cat: 'code', dis: 20};
  discounts['birthday30'] = {cat: 'code', dis: 30};
  discounts['mara20'] = {cat: 'code', dis: 20};
  discounts['tegernsee30'] = {cat: 'code', dis: 30};
  discounts['nadi30'] = {cat: 'code', dis: 30};
  discounts['katrin-u30'] = {cat: 'code', dis: 30};
  discounts['ninabott30'] = {cat: 'code', dis: 30};
  discounts['gina30'] = {cat: 'code', dis: 30};
  discounts['valeska30'] = {cat: 'code', dis: 30};
  discounts['maxi30'] = {cat: 'code', dis: 30};
  discounts['sunna30'] = {cat: 'code', dis: 30};
  discounts['katha30'] = {cat: 'code', dis: 30};
  discounts['tasdy30'] = {cat: 'code', dis: 30};
  discounts['kate20'] = {cat: 'code', dis: 20};
  discounts['anja30'] = {cat: 'code', dis: 30};
  discounts['boris30'] = {cat: 'code', dis: 30};
  discounts['xmas25'] = {cat: 'code', dis: 25};
  discounts['danke30'] = {cat: 'code', dis: 30};
  discounts['danke2025'] = {cat: 'code', dis: 25};
  discounts['umfrage30'] = {cat: 'code', dis: 30};
  discounts['testerset-insta'] = {cat: 'vip-code-testerset', dis: 20};
  discounts['testerset'] = {cat: 'vip-code-testerset', dis: 20};
  discounts['testerset20'] = {cat: 'vip-code-testerset', dis: 20};
  discounts['testersetinsta'] = {cat: 'vip-code-testerset', dis: 20};
  discounts['testersetm'] = {cat: 'code', dis: 20};
  discounts['testersetgoogle'] = {cat: 'vip-code-testerset', dis: 20};
  discounts['testersetg'] = {cat: 'code-testersetg', dis: 20};
  discounts['toyah20'] = {cat: 'code', dis: 20};
  discounts['esther20'] = {cat: 'code', dis: 20};
  discounts['nadi20'] = {cat: 'code', dis: 20};
  discounts['katerina20'] = {cat: 'code', dis: 20};
  discounts['hannahandthetriplets20'] = {cat: 'code', dis: 20};
  discounts['claudi20'] = {cat: 'code', dis: 20};
  discounts['alina2026'] = {cat: 'code', dis: 20};
  discounts['hannah20'] = {cat: 'code', dis: 20};
  discounts['double25'] = {cat: 'code-double25', dis: 25};
  discounts['maleen20'] = {cat: 'code', dis: 20};
  discounts['ninabott20'] = {cat: 'code', dis: 20};
  discounts['elisabeth20'] = {cat: 'code', dis: 20};
  discounts['kati20'] = {cat: 'code', dis: 20};
  discounts['su20'] = {cat: 'code', dis: 20};
  discounts['alina20'] = {cat: 'code', dis: 20};
  discounts['max20'] = {cat: 'code', dis: 20};
  discounts['jenny20'] = {cat: 'code', dis: 20};
  discounts['sweet20'] = {cat: 'code', dis: 20};
  discounts['verena20'] = {cat: 'code', dis: 20};
  discounts['lori20'] = {cat: 'code', dis: 20};
  discounts['stephanie20'] = {cat: 'code', dis: 20};
  discounts['andrea20'] = {cat: 'code', dis: 20};
  discounts['anna20'] = {cat: 'code', dis: 20};
  discounts['annka20'] = {cat: 'code', dis: 20};
  discounts['erhardprien20'] = {cat: 'code', dis: 20};
  discounts['bella20'] = {cat: 'code', dis: 20};
  discounts['jennifer20'] = {cat: 'code', dis: 20};
  discounts['sabina20'] = {cat: 'code', dis: 20};
  discounts['joanna20'] = {cat: 'code', dis: 20};
  discounts['sibylle20'] = {cat: 'code', dis: 20};
  discounts['christina20'] = {cat: 'code', dis: 20};
  discounts['katrin20'] = {cat: 'code', dis: 20};
  discounts['anni20'] = {cat: 'code', dis: 20};
  discounts['claudia20'] = {cat: 'code', dis: 20};
  discounts['anett20'] = {cat: 'code', dis: 20};
  discounts['nadja20'] = {cat: 'code', dis: 20};
  discounts['claudelle20'] = {cat: 'code', dis: 20};
  discounts['melina20'] = {cat: 'code', dis: 20};
  discounts['butik20'] = {cat: 'code', dis: 20};
  discounts['isabel20'] = {cat: 'code', dis: 20};
  discounts['sabrina30'] = {cat: 'code', dis: 30};
  discounts['lilli22'] = {cat: 'code', dis: 22};
  discounts['claudia22'] = {cat: 'code', dis: 22};
  discounts['schminktante22'] = {cat: 'code', dis: 22};
  discounts['jelena22'] = {cat: 'code', dis: 22};
  discounts['julia22'] = {cat: 'code', dis: 22};
  discounts['finja22'] = {cat: 'code', dis: 22};
  discounts['fiona22'] = {cat: 'code', dis: 22};
  discounts['claudelle22'] = {cat: 'code', dis: 22};
  discounts['ami22'] = {cat: 'code', dis: 22};
  discounts['elise22'] = {cat: 'code', dis: 22};
  discounts['valeska22'] = {cat: 'code', dis: 22};
  discounts['saskia22'] = {cat: 'code', dis: 22};
  discounts['marie20'] = {cat: 'code', dis: 20};
  discounts['julia-s22'] = {cat: 'code', dis: 22};
  discounts['franzi22'] = {cat: 'code', dis: 22};
  discounts['pia22'] = {cat: 'code', dis: 22};
  discounts['denise22'] = {cat: 'code', dis: 22};
  discounts['sophi22'] = {cat: 'code', dis: 22};
  discounts['erhard26'] = {cat: 'code', dis: 26};
  discounts['xbyx25'] = {cat: 'code', dis: 25};
  discounts['women30'] = {cat: 'code', dis: 30};
  discounts['women30m'] = {cat: 'code', dis: 30};
  discounts['women30g'] = {cat: 'code', dis: 30};
  discounts['women30wa'] = {cat: 'code', dis: 30};
  discounts['women30nl'] = {cat: 'code', dis: 30};
  discounts['love26'] = {cat: 'code', dis: 26};
  discounts['love25'] = {cat: 'code', dis: 25};
  discounts['love26wa'] = {cat: 'code', dis: 26};
  discounts['profschoettle'] = {cat: 'code-event', dis: 30};
  discounts['ostern25'] = {cat: 'code', dis: 25};
  discounts['ostern25nl'] = {cat: 'code', dis: 25};
  discounts['ostern25wa'] = {cat: 'code', dis: 25};
  discounts['ostern50m'] = {cat: 'code-testerset-neukunden', dis: 20};
  discounts['ostern50g'] = {cat: 'code-testerset-neukunden', dis: 20};
  discounts['ostern50nl'] = {cat: 'code-testerset-neukunden', dis: 20};
  discounts['ostern50wa'] = {cat: 'code-testerset-neukunden', dis: 20};
  discounts['styling22'] = {cat: 'code', dis: 22};
  discounts['vip-set-40'] = {cat: 'code-produkte', dis: 40};
  discounts['elise30'] = {cat: 'code', dis: 30};
  discounts['settebello30'] = {cat: 'code', dis: 30};
  discounts['lydia30'] = {cat: 'code', dis: 30};
  discounts['juli30'] = {cat: 'code', dis: 30};
  discounts['toyah30'] = {cat: 'code', dis: 30};
  discounts['serena30'] = {cat: 'code', dis: 30};
  discounts['butik30'] = {cat: 'code', dis: 30};
  discounts['ami30'] = {cat: 'code', dis: 30};
  discounts['nina30'] = {cat: 'code', dis: 30};
  discounts['sue30'] = {cat: 'code', dis: 30};
  discounts['mama30'] = {cat: 'code', dis: 30};
  discounts['mama30m'] = {cat: 'code', dis: 30};
  discounts['mama30g'] = {cat: 'code', dis: 30};
  discounts['mama30wa'] = {cat: 'code', dis: 30};
  discounts['mama30nl'] = {cat: 'code', dis: 30};
  discounts['charlotte30'] = {cat: 'code', dis: 30};
  discounts['elena30'] = {cat: 'code', dis: 30};
  discounts['joanna30'] = {cat: 'code', dis: 30};
  discounts['max30'] = {cat: 'code', dis: 30};
  discounts['andrea30'] = {cat: 'code', dis: 30};
  discounts['franzi30'] = {cat: 'code', dis: 30};
  discounts['eileen30'] = {cat: 'code', dis: 30};
  discounts['milenka30'] = {cat: 'code', dis: 30};
  discounts['lynn30'] = {cat: 'code', dis: 30};
  discounts['sandra30'] = {cat: 'code', dis: 30};
  discounts['hannahandthetriplets30'] = {cat: 'code', dis: 30};
  discounts['shari30'] = {cat: 'code', dis: 30};
  discounts['simone30'] = {cat: 'code', dis: 30};
  discounts['clara30'] = {cat: 'code', dis: 30};
  discounts['diana30'] = {cat: 'code', dis: 30};
  discounts['moai30'] = {cat: 'code', dis: 30};
  discounts['su30'] = {cat: 'code', dis: 30};
  discounts['jelena30'] = {cat: 'code', dis: 30};
  discounts['katerina30'] = {cat: 'code', dis: 30};
  discounts['baaam30'] = {cat: 'code', dis: 30};
  discounts['eva30'] = {cat: 'code', dis: 30};
  discounts['elisabeth30'] = {cat: 'code', dis: 30};
  discounts['pomponetti30'] = {cat: 'code', dis: 30};
  discounts['kate30'] = {cat: 'code', dis: 30};
  discounts['susanne30'] = {cat: 'code', dis: 30};
  discounts['lori30'] = {cat: 'code', dis: 30};
  discounts['ron30'] = {cat: 'code', dis: 30};
  discounts['olly30'] = {cat: 'code', dis: 30};
  discounts['vera30'] = {cat: 'code', dis: 30};
  discounts['hannah30'] = {cat: 'code', dis: 30};
  discounts['tanja30'] = {cat: 'code', dis: 30};
  discounts['ursula30'] = {cat: 'code', dis: 30};
  discounts['julia30'] = {cat: 'code', dis: 30};
  discounts['fiona30'] = {cat: 'code', dis: 30};
  discounts['steph30'] = {cat: 'code', dis: 30};
  discounts['imke30'] = {cat: 'code', dis: 30};
  discounts['xlset'] = {cat: 'code', dis: 22};
  discounts['xl-set'] = {cat: 'code', dis: 22};
  discounts['summer22'] = {cat: 'code', dis: 22};
  discounts['onnilove22'] = {cat: 'code', dis: 22};
  discounts['summer30'] = {cat: 'code', dis: 30};
  discounts['summer30m'] = {cat: 'code', dis: 30};
  discounts['summer30g'] = {cat: 'code', dis: 30};
  discounts['summer30wa'] = {cat: 'code', dis: 30};
  discounts['summer30nl'] = {cat: 'code', dis: 30};
  discounts['lindaloves30'] = {cat: 'code', dis: 30};
  discounts['mareike30'] = {cat: 'code', dis: 30};
  discounts['denise30'] = {cat: 'code', dis: 30};
  discounts['menomio22'] = {cat: 'code', dis: 22};
  discounts['petra30'] = {cat: 'code', dis: 30};
  discounts['petra22'] = {cat: 'code', dis: 22};
  discounts['veronique30'] = {cat: 'code', dis: 30};
  discounts['claudelle30'] = {cat: 'code', dis: 30};
  discounts['ines30'] = {cat: 'code', dis: 30};
  discounts['konfetti30'] = {cat: 'code', dis: 30};
  discounts['anna30'] = {cat: 'code', dis: 30};
  discounts['lena22'] = {cat: 'code', dis: 22};
  discounts['summersale'] = {cat: 'code', dis: 30};
  discounts['boris22'] = {cat: 'code', dis: 22};
  discounts['diana22'] = {cat: 'code', dis: 22};
  discounts['isabel22'] = {cat: 'code', dis: 22};
  discounts['vera22'] = {cat: 'code', dis: 22};
  discounts['juli22'] = {cat: 'code', dis: 22};
  discounts['hannahandthetriplets22'] = {cat: 'code', dis: 22};
  discounts['alexj22'] = {cat: 'code', dis: 22};
  discounts['ani22'] = {cat: 'code', dis: 22};
  discounts['teresa22'] = {cat: 'code', dis: 22};
  discounts['cindy22'] = {cat: 'code', dis: 22};
  discounts['joanna22'] = {cat: 'code', dis: 22};
  discounts['laura22'] = {cat: 'code', dis: 22};
  discounts['romy22'] = {cat: 'code', dis: 22};
  discounts['kathi22'] = {cat: 'code', dis: 22};
  discounts['michaela22'] = {cat: 'code', dis: 20};

  // 29.07.2026 nachgetragen nach Abgleich mit den echten Shopify-Rabattcodes:
  // diese drei fehlen in der aufgeraeumten Liste, sind in Shopify aber AKTIV.
  // Ohne sie zeigt der Shop bei diesen Codes keinen VIP-Balken und keinen Streichpreis.
  discounts['jessi20'] = {cat: 'code', dis: 20};
  discounts['nina20'] = {cat: 'code', dis: 20};
  discounts['steph20'] = {cat: 'code', dis: 20};
  // 03.08.2026 LENA Influencer: diese Zeilen standen faelschlich NACH dem IIFE-Ende.
  // Dort ist "discounts" nicht sichtbar -> ReferenceError, kein Code wurde mehr angezeigt.
  discounts['lena30'] = {cat: 'code', dis: 30};
  discounts['moai22'] = {cat: 'code', dis: 22};
  discounts['su22'] = {cat: 'code', dis: 22};
  discounts['tami22'] = {cat: 'code', dis: 22};
  discounts['tegernsee22'] = {cat: 'code', dis: 22};
  discounts['antje22'] = {cat: 'code', dis: 22};
  discounts['feli22'] = {cat: 'code', dis: 22};
  discounts['nina22'] = {cat: 'code', dis: 22};
  discounts['andrea22'] = {cat: 'code', dis: 22};
  discounts['ursula22'] = {cat: 'code', dis: 22};
  discounts['fatma22'] = {cat: 'code', dis: 22};
  discounts['tanja22'] = {cat: 'code', dis: 22};
  discounts['tanjaweber22'] = {cat: 'code', dis: 22};
  discounts['imke22'] = {cat: 'code', dis: 22};
  discounts['konfeti22'] = {cat: 'code', dis: 22};
  discounts['emina30'] = {cat: 'code', dis: 30};
  discounts['ines22'] = {cat: 'code', dis: 22};
  discounts['flash30'] = {cat: 'code', dis: 30};
  discounts['katrin22'] = {cat: 'code', dis: 22};
  discounts['flash25'] = {cat: 'code', dis: 25};
  discounts['jennifer22'] = {cat: 'code', dis: 22};
  discounts['pomponetti22'] = {cat: 'code', dis: 22};
  discounts['serena22'] = {cat: 'code', dis: 22};
  discounts['susanne22'] = {cat: 'code', dis: 22};
  discounts['verena22'] = {cat: 'code', dis: 22};  // 18.08.2026: Slug umgezogen von verena-a22-2026 -> verena22-2026. Rücknahme: Link 574815 custom-slug, Voucher 268246 code, Koop 404986 klar_voucher_code, Shopify-Code verena-a22 (gid 2044377399561) bleibt aktiv.
  discounts['max22'] = {cat: 'code', dis: 22};
  discounts['kate22'] = {cat: 'code', dis: 22};
  discounts['baaam22'] = {cat: 'code', dis: 22};
  discounts['xxl99'] = {cat: 'code-xxl99', fixed: 49};
  discounts['wiesn26'] = {cat: 'code', dis: 26};
  discounts['carolin30'] = {cat: 'code', dis: 30};
  discounts['tasja30'] = {cat: 'code', dis: 30};
  discounts['marlene30'] = {cat: 'code', dis: 30};
  discounts['viktoria30'] = {cat: 'code', dis: 30};
  discounts['oursweetliving30'] = {cat: 'code', dis: 30};
  discounts['dahoam22'] = {cat: 'code', dis: 22};
  discounts['verena30'] = {cat: 'code', dis: 30};
  discounts['maren22'] = {cat: 'code', dis: 22};
  discounts['jenny22'] = {cat: 'code', dis: 22};
  discounts['oktoberfest26'] = {cat: 'code', dis: 26};
  discounts['oktoberfest26nl'] = {cat: 'code', dis: 26};
  discounts['oktoberfest26insta'] = {cat: 'code', dis: 26};
  discounts['oktoberfest26wa'] = {cat: 'code', dis: 26};
  discounts['onni26'] = {cat: 'code', dis: 26};
  discounts['oktoberfest26m'] = {cat: 'code', dis: 26};
  discounts['curvywelt30'] = {cat: 'code', dis: 30};
  discounts['lorilove22'] = {cat: 'code', dis: 22};
  discounts['jenny30'] = {cat: 'code', dis: 30};
  discounts['jacks30'] = {cat: 'code', dis: 30};
  discounts['fatma30'] = {cat: 'code', dis: 30};
  discounts['katrin30'] = {cat: 'code', dis: 30};

  
  // BIG Birthday 2026 (Paavo 30.09.2026): 30 % auf code-birthday-2026, ohne die BIG Birthday Sets
  discounts['birthday2026'] = {cat: 'code-birthday-2026', dis: 30};
  discounts['birthday2026nl'] = {cat: 'code-birthday-2026', dis: 30};
  discounts['birthday2026wa'] = {cat: 'code-birthday-2026', dis: 30};
  discounts['birthday2026g'] = {cat: 'code-birthday-2026', dis: 30};
  discounts['birthday2026m'] = {cat: 'code-birthday-2026', dis: 30};
  // bday30 (Paavo 03.10.2026): Shopify-Rabatt 01.10. bis 15.10.2026, seit 03.10. abends auf Collection code
  discounts['bday30'] = {cat: 'code', dis: 30};
  // bday30wa (Paavo 03.10.2026): Shopify-Rabatt 01.10. bis 15.10.2026 auf Collection code (nicht code-birthday-2026)
  discounts['bday30wa'] = {cat: 'code', dis: 30};
  // bday30nl (Paavo 03.10.2026): Shopify-Rabatt 01.10. bis 15.10.2026 auf Collection code
  discounts['bday30nl'] = {cat: 'code', dis: 30};
  discounts['isabel30'] = {cat: 'code', dis: 30};
  discounts['diva20'] = {cat: 'code', dis: 20};
  discounts['pause30'] = {cat: 'code', dis: 30};
  discounts['romy30'] = {cat: 'code', dis: 30};
  discounts['annaleixnering'] = {cat: 'code', dis: 22};
  discounts['annaleix30'] = {cat: 'code', dis: 30};
  // birthday2026nla (Paavo 11.10.2026): Abend-Newsletter, NL-Code ohne A gilt für morgens, Kopie von birthday2026nl, bis 15.10.2026
  discounts['birthday2026nla'] = {cat: 'code-birthday-2026', dis: 30};
  // birthday2026waa (Paavo 24.10.2026): WhatsApp-Abend, Kopie von birthday2026wa, aktiv bis 31.12.2026
  discounts['birthday2026waa'] = {cat: 'code-birthday-2026', dis: 30};
  // nohi30 (LENA Influencer 13.10.2026): Creator nohi.loves.eli, Black Friday 2026, Collection code, ab 50 €, bis 31.12.2026
  discounts['nohi30'] = {cat: 'code', dis: 30};
  // linda30 (LENA Influencer 13.10.2026): Creator linda_schreibt, Black Friday 2026, Collection code,
  // ab 50 €, bis 31.12.2026. Eigener Code, nicht zu verwechseln mit lindaloves30 und linda20.
  discounts['linda30'] = {cat: 'code', dis: 30};
  // nadine30 (LENA Influencer 16.10.2026): Creator nadine6809 (SC Media House), Story 16.11., Collection code, ab 50 €, Limit 500, bis 31.12.2026
  discounts['nadine30'] = {cat: 'code', dis: 30};
  // kathy30 (LENA Influencer für Emina 20.10.2026): Black Friday 2026, Collection code, ab 50 €, Limit 500, bis 31.12.2026
  discounts['kathy30'] = {cat: 'code', dis: 30};
  // caro30 (LENA Influencer für Emina 20.10.2026): Black Friday 2026, Collection code, ab 50 €, Limit 500, bis 31.12.2026
  discounts['caro30'] = {cat: 'code', dis: 30};
  // gaby20 (LENA Influencer, Auftrag Hanna von Pflug 23.10.2026): Creator Gaby Muller, Barterdeal, Collection code, ab 50 €, Limit 500, bis 31.12.2026
  discounts['gaby20'] = {cat: 'code', dis: 20};
  // donna30/myself30 bewusst nicht hier (Johannes 26.10.2026): gelten in Shopify nur für das HHD-2027-Ticket
  // Black-Friday-Koops ab 15.11. (LENA Influencer 27.10.2026): Collection code, ab 50 €, in Shopify aktiv seit 27.10.2026
  discounts['teresa30'] = {cat: 'code', dis: 30};
  discounts['svenja30'] = {cat: 'code', dis: 30};
  discounts['sally30'] = {cat: 'code', dis: 30};
  discounts['sophiekate30'] = {cat: 'code', dis: 30};
  // dahoam30 (LENA Influencer 27.10.2026): Black-Friday-Koop 23.11., Collection code, ab 50 €, in Shopify aktiv seit 27.10.2026
  discounts['dahoam30'] = {cat: 'code', dis: 30};
  // sophie30 (LENA Influencer 27.10.2026): Bestandscode, ab jetzt Black-Friday-Code von sophiiekate (22.11.), Collection code, ab 50 €; sophiekate30 bleibt
  discounts['sophie30'] = {cat: 'code', dis: 30};
  // vip-set-30 (Ada 27.10.2026, Paavo GO): fester Code eigener Set Creator 30er, Kollektion vip-code-vip-set-40, ab 5 Stück, in Shopify aktiv seit 27.10.2026
  discounts['vip-set-30'] = {cat: 'code-produkte', dis: 30};
  // ^^^ NEUE CODES BITTE HIER DARUNTER ANHAENGEN, nicht einsortieren.
  //     IMMER klein schreiben, der Lookup normalisiert eingehende Codes auf Kleinschrift. ^^^

  /* Ablaufdatum je Code (Johannes 20.10.2026). Ab dem Zeitpunkt zeigt der Shop fuer diesen Code
     keine Rabattpreise mehr, und alte Cookies werden abgeraeumt. Gleicher Zeitpunkt wie endsAt
     des Shopify-Rabatts, sonst zeigt der Shop Preise, die der Checkout nicht mehr gibt.
     Format ISO mit Z (UTC). 2026-10-20T21:59:59Z = 20.10.2026 23:59:59 Berlin.
     Paavo 24.10.2026: Birthday-Codes wieder aktiv bis 31.12.2026 23:59:59 Berlin (2026-12-31T22:59:59Z),
     bis er sie früher abschaltet. Dann hier UND endsAt in Shopify gleich setzen. */
  var ONNI_CODE_ENDE = {
    'birthday2026': '2026-12-31T22:59:59Z', 'birthday2026nl': '2026-12-31T22:59:59Z',
    'birthday2026wa': '2026-12-31T22:59:59Z', 'birthday2026g': '2026-12-31T22:59:59Z',
    'birthday2026m': '2026-12-31T22:59:59Z', 'birthday2026nla': '2026-12-31T22:59:59Z',
    'bday30': '2026-12-31T22:59:59Z', 'bday30wa': '2026-12-31T22:59:59Z',
    'bday30nl': '2026-12-31T22:59:59Z', 'birthday2026waa': '2026-12-31T22:59:59Z'
  };
  (function () {
    var jetzt = Date.now();
    Object.keys(ONNI_CODE_ENDE).forEach(function (c) {
      if (jetzt > Date.parse(ONNI_CODE_ENDE[c])) { delete discounts[c]; delete discountmix[c]; }
    });
  })();

  /* ONNI Flashday (Ada 13.08.2026): zeitlich begrenzte Aktion auf alles, ohne Code.
     Der interne Code wird aus den Theme-Einstellungen angemeldet und von
     assets/onni-flashday.js waehrend des Zeitfensters ins Cookie gesetzt. Ab da
     laeuft die Preisanzeige durch dieselbe, erprobte Strecke wie bei jedem VIP-Code.
     Ohne aktives Fenster existiert der Eintrag zwar, wird aber von niemandem gezogen. */
  /* 19.10.2026 Ada (Johannes, Code-Review A-01): nur waehrend des Fensters. Den Wert
     ONNI_FLASH.aktiv setzt onni-flashday.js (laeuft vorher). Ohne ihn war der Code
     immer gueltig, solange der Schalter an stand, auch per #onni-flashday nach der Aktion. */
  var ONNI_FLASH = (window.ONNI_FLASH && window.ONNI_FLASH.on && window.ONNI_FLASH.aktiv === true) ? window.ONNI_FLASH : null;
  if (ONNI_FLASH) {
    discounts[String(ONNI_FLASH.code).toLowerCase()] = {cat: ONNI_FLASH.cat, dis: ONNI_FLASH.percent};
  }

  /* ONNI Einzelcodes per Präfix (Ada 21.10.2026, LENA Klaviyo, OK Johannes): WhatsApp-Codes
     heißen je Kundin anders (VIP20-29X, WAAC20-2RBTE ...) und stehen deshalb nicht in der
     Liste oben. Unbekannte Codes mit diesen Anfängen gelten wie ein Listeneintrag.
     Bewusst ohne Gültigkeitsprüfung: auch ein schon eingelöster Einzelcode zeigt den
     Preis, Shopify lehnt ihn dann erst an der Kasse ab. */
  var ONNI_CODE_PRAEFIX = [
    {p: 'vip20-', cat: 'code', dis: 20},
    {p: 'waac20-', cat: 'code', dis: 20},
    {p: 'wawb20-', cat: 'code', dis: 20},
    {p: 'wavip20-', cat: 'code', dis: 20},
    /* Einzelcodes eigener Set Creator (Ada 22.10.2026): VIP-SET-40-XXXXXX, je Code einmal nutzbar,
       40 % auf Kollektion vip-code-vip-set-40 ab 5 Stück. Die Bundler-Codes VIP-SET-40-[xxx]
       fallen ebenfalls darunter, gleicher Rabatt. */
    {p: 'vip-set-40-', cat: 'code-produkte', dis: 40, stk: 5}
  ];
  function praefixAnmelden(c) {
    if (!c || discounts[c] || discountmix[c]) { return; }
    for (var i = 0; i < ONNI_CODE_PRAEFIX.length; i++) {
      var r = ONNI_CODE_PRAEFIX[i];
      if (c.indexOf(r.p) === 0 && c.length > r.p.length) {
        discounts[c] = {cat: r.cat, dis: r.dis};
        if (r.stk) { discounts[c].stk = r.stk; }
        return;
      }
    }
  }

  /* Beim Flashday gibt es keinen Code zum Vorzeigen. Die Pille zeigt deshalb den
     Aktionsnamen statt der internen Kennung. */
  /* Beim Flashday gilt der Rabatt fuer ALLES. Die Zuordnung ueber Collections
     (data-discount) wird dann bewusst uebersprungen: sie haengt an product.collections,
     und das ist in Liquid gedeckelt. Ein Produkt in vielen Collections waere sonst
     stillschweigend vom Rabatt ausgenommen, obwohl der Checkout ihn gewaehrt. */
  function onniFlashAktiv() {
    return !!(ONNI_FLASH && ONNI_FLASH.on && discount_code === String(ONNI_FLASH.code).toLowerCase());
  }

  /* Euro-Codes (fixed / moneyoff) sprechen ueberall in Euro, nie in Prozent: der
     Checkout zieht einen festen Betrag ab, also nennt auch die Uebersicht den Betrag.
     (Paavo 22.08.2026) */
  function onniEuroChip(betrag) {
    return '\u2212' + ONNI_PREIS.euro(betrag) + ' €';
  }

  function onniChipLbl() {
    if (onniFlashAktiv()) { return ''; }
    // 02.10.2026 (Paavo): „Code:“ statt „VIP:“
    return '<span class="onni-chip__lbl">Code:</span> ';
  }

  /* An der Ware steht der Rabattcode selbst, nicht der Aktionsname: die Pille sagt
     dem Kunden, was auf seinem Warenkorb liegt. Der lange Name gehoert in Balken und
     Fenster, dort wird die Aktion angekuendigt. (Paavo 14.08.2026) */
  function onniCodeLabel(code) {
    if (ONNI_FLASH && ONNI_FLASH.on && code === String(ONNI_FLASH.code).toLowerCase()) {
      return ONNI_FLASH.cart_code || ONNI_FLASH.title || 'FLASH';
    }
    return code;
  }



  /* Varianten-Kacheln auf der PDP (Paavo 02.10.2026): Bei aktivem Code zeigt jede
     Groessen-Kachel den Code-Preis und darueber klein den durchgestrichenen
     Listenpreis, der Grundpreis wird mit demselben Faktor umgerechnet. Vorher stand
     oben 83,30 EUR und in der Kachel weiter 119,00 EUR. rechner(listenpreis) liefert
     den Code-Preis, genau wie oben in der Preiszeile. */
  function onniVariantenKacheln(scope, rechner) {
    var kacheln = (scope || document).querySelectorAll('.onni-variants a.onni-variant');
    kacheln.forEach(function (a) {
      if (a.getAttribute('data-onni-vt')) { return; }
      if (a.classList.contains('onni-variant-soldout')) { return; } // ausverkauft: Listenpreis bleibt durchgestrichen stehen
      var preisEl = a.querySelector('.price');
      if (!preisEl) { return; }
      var badge = preisEl.querySelector('.savings-badge');
      var preisText = preisEl.textContent.replace(badge ? badge.textContent : '', '').trim();
      var alt = ONNI_PREIS.zahl(preisText);
      var neu = rechner(alt);
      if (!isFinite(alt) || !isFinite(neu) || alt <= 0 || neu >= alt) { return; }
      a.setAttribute('data-onni-vt', '1');
      preisEl.innerHTML = '<s class="onni-vt-alt">' + ONNI_PREIS.euro(alt) + ' €</s>' + ONNI_PREIS.euro(neu) + ' €' + (badge ? badge.outerHTML : '');
      var gp = a.querySelector('.onni-unit-price');
      if (gp) {
        gp.textContent = onniGrundpreisUmrechnen(gp.textContent.trim(), neu / alt);
      }
    });
  }

  function getCookie(name) {      
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  /* ONNI 07.08.2026 (Paavo): Der VIP-Code lag bisher NUR in `discount_code`.
     Dieses Cookie gehoert aber Shopify: `/discount/<code>` setzt es, und der
     Checkout raeumt es beim Betreten wieder ab, sobald er den Code uebernommen
     hat. Gemessen: nach einem Checkout-Besuch war das Cookie leer, VIP-Balken
     und reduzierte Preise blieben fuer den Rest der Sitzung weg — obwohl der
     Rabatt im Checkout weiter griff.

     Deshalb zwei Cookies mit klarer Aufgabenteilung:
       discount_code   gehoert Shopify, wir setzen ihn weiter, damit der
                       Checkout den Code bekommt. Dass Shopify ihn aufraeumt,
                       ist ab jetzt egal.
       onni_vip_code   gehoert uns und speist allein die ANZEIGE. Mit Laufzeit,
                       damit der Code auch einen Tabwechsel ueberlebt. */
  var VIP_COOKIE = 'onni_vip_code';
  var VIP_TAGE = 7;

  function setzeVipCode(code) {
    // Code-Review A-01: Den Flash-Code verwaltet onni-flashday.js selbst (Cookie nur fuers
    // Fenster). Nie 7 Tage ins Anzeige-Cookie, sonst ueberlebt er die Aktion.
    if (window.ONNI_FLASH && code === String(window.ONNI_FLASH.code).toLowerCase()) { return; }
    document.cookie = 'discount_code=' + code + '; path=/';
    document.cookie = VIP_COOKIE + '=' + code + '; path=/; max-age=' + (VIP_TAGE * 86400) + '; SameSite=Lax';
  }



  /* Code-Review A-08 (Johannes 28.10.2026): Code-Preise an EINER Stelle.
     Vorher standen displayDiscountMix() und displayDiscount() je rund 150 Zeilen fast
     wortgleich nebeneinander (Set-Anker, Chips, Badge, Grundpreis, Legacy-Zweig), jede
     Aenderung musste doppelt gemacht werden. Jetzt liefern beide Wege nur noch den
     Rabatt ({euro} oder {prozent}, siehe ONNI_PREIS.rabatt), angezeigt wird in
     onniCodePreisZeigen. Gerechnet wird ausschliesslich ueber ONNI_PREIS oben.
     Sichtbares Ergebnis unveraendert, Vorher/Nachher-Messlauf in
     projekte/ONNI/codereview-schritt7-a08. */
  function onniCodePreisZeigen(item, rabatt) {

          // hide double strike price
          let hide = item.querySelector('.compare-at-price');
          if (hide) {
            hide.style.display = 'none';
          }

          // ONNI 06.08.2026: deutsches Zahlenformat sauber lesen, siehe onniPreisZuZahl.
          var oldprice = ONNI_PREIS.zahl(item.getAttribute('data-price').trim());

          var euroModus = rabatt.euro !== undefined;
          var newpriceNum = ONNI_PREIS.codePreis(oldprice, rabatt);
          var chip2 = euroModus ? onniEuroChip(oldprice - newpriceNum) : '−' + rabatt.prozent + '%';
          var chip3 = ONNI_PREIS.euro(oldprice - newpriceNum) + ' € ' + ONNI_SAVED;
          var newprice = ONNI_PREIS.euro(newpriceNum);
          if (item.closest('product-price') && !item.closest('product-card')) {
            onniVariantenKacheln(item.closest('.shopify-section'), function (p) {
              return ONNI_PREIS.codePreis(p, rabatt);
            });
          }

          if (item.closest('product-price')) {
            // PDP-Buybox: kompakte Preiszeile + Chip-Reihe (Paavo 18.07.2026)
            // Produktkarten: Prozent-Chip wandert als rotes Sale-Badge oben rechts ins Bild,
            // unten bleiben nur VIP-Code + gespart, etwas groesser (Paavo 19.07.2026)
            var card = item.closest('product-card');
            item.getElementsByClassName('price')[0].style.display = 'none';
            var savEl = item.querySelector('.savings'); if (savEl) { savEl.style.display = 'none'; }
            var oldTxt = ONNI_PREIS.euro(oldprice);
            // ONNI Sets (19.07.2026): Anker = Einzelpreis-Summe statt Set-Streichpreis.
            // Badge + "gespart" beziehen sich auf den Einzelkauf, das Preisinfo-Modal
            // ([data-pi]-Spans in .onni-set-extras) wird auf den Code-Preis aktualisiert.
            var setTotal = parseInt(item.getAttribute('data-onni-single-total') || '0', 10) / 100;
            var lowest30 = parseInt(item.getAttribute('data-onni-lowest30') || '0', 10) / 100;
            // Paavo 19.07.2026: Anker ist IMMER der gepflegte (gerundete) Vergleichspreis;
            // die exakte Einzelsumme aus dem Metafeld greift nur, wenn keiner gepflegt ist
            if (hide) {
              var caNum = ONNI_PREIS.zahl(hide.textContent);
              if (caNum && caNum > oldprice) { setTotal = caNum; }
            }
            var strike = '<s>'+oldTxt+' €</s>';
            if (setTotal > 0) {
              /* Der Anker ist bei Sets die Einzelpreis-Summe. Der Badge folgt der Art des
                 Codes: Prozentcode -> Prozent, Eurocode -> Euro. Das Preisinfo-Fenster
                 zeigt weiterhin beides. (Paavo 22.08.2026) */
              /* Birthday-Sets (Paavo 10.10.2026): nur glatte 5er-Stufen, immer abrunden (57 -> 55) */
              var pctStufe = parseInt(item.getAttribute('data-onni-pct-stufe') || '1', 10) || 1;
              var pctTxt = '−' + ONNI_PREIS.prozent(setTotal, newpriceNum, pctStufe) + '%';
              chip2 = euroModus ? onniEuroChip(setTotal - newpriceNum) : pctTxt;
              chip3 = ONNI_PREIS.euro(setTotal - newpriceNum) + ' € ' + ONNI_SAVED;
              strike = '<s>'+ONNI_PREIS.euro(setTotal)+' €</s>';
              var extras = item.parentElement.querySelector('.onni-set-extras');
              if (extras) {
                var baseChips = extras.querySelector('.onni-set-chips'); if (baseChips) { baseChips.remove(); }
                var setPi = function (key, txt) { var el = extras.querySelector('[data-pi="'+key+'"]'); if (el) { el.textContent = txt; } };
                setPi('today', newprice + ' €');
                setPi('singleamt', chip3.replace(' ' + ONNI_SAVED, ''));
                setPi('singlepct', pctTxt);
                if (lowest30 > 0 && newpriceNum < lowest30) {
                  setPi('d30amt', ONNI_PREIS.euro(lowest30 - newpriceNum) + ' €');
                  setPi('d30pct', '−' + ONNI_PREIS.prozent(lowest30, newpriceNum) + '%');
                  var d30 = extras.querySelector('[data-pi="d30clause"]'); if (d30) { d30.style.display = ''; }
                }
              }
            }
            var chips;
            // Kombi-Pill "VIP: CODE > X EUR gespart" bei aktivem Code auf ALLEN Produkten
            // (Paavo 21.07.); bei Sets ist der Anker die Einzelpreis-Summe, sonst der Code-Rabatt
            if (chip3) {
              // Betrag und das Wort "gespart" getrennt ausgeben (Paavo 01.08.2026): auf dem Handy
              // wird das Wort per CSS ausgeblendet und stattdessen das Minus gezeigt, aus
              // "VIP: CODE > 6,00 EUR gespart" wird dort "VIP: CODE > -6,00 EUR".
              chips = '<span class="onni-chip onni-chip--vipsave">'+onniChipLbl()+'<b class="onni-chip__code">'+onniCodeLabel(discount_code)+'</b><span class="onni-chip__sep">&rsaquo;</span><span class="onni-chip__minus">−</span><span class="onni-chip__amt">'+chip3.replace(' ' + ONNI_SAVED, '')+'</span> <span class="onni-chip__saved">'+ONNI_SAVED+'</span></span>';
            } else {
              // gleiche gruene Pille wie beim Set, nur ohne gespart-Teil (Farbsystem: VIP immer gruen)
              chips = '<span class="onni-chip onni-chip--vipsave">'+onniChipLbl()+'<b class="onni-chip__code">'+onniCodeLabel(discount_code)+'</b></span>';
            }
            // Prozent als gruener Button hinter dem VIP-Button NUR auf der PDP (Paavo 19.07.);
            // auf Karten reicht das rote Badge oben rechts im Bild
            if (!card && chip2) { chips += '<span class="onni-chip onni-chip--pct">'+chip2+'</span>'; }
            if (!card) {
              // PDP (Paavo 19.07.): Prozent als rotes Badge oben rechts im Produktbild, wie auf den Karten
              var pdpMedia = document.querySelector('.product-information__media');
              if (pdpMedia) {
                // Ins Bild setzen: an der Galerie verankern, nicht am Media-Container (Paavo 19.07.)
                pdpMedia = pdpMedia.querySelector('media-gallery') || pdpMedia;
                var pdpBadge = pdpMedia.querySelector('.onni-sale-badge');
                if (!pdpBadge) {
                  pdpBadge = document.createElement('span');
                  pdpBadge.className = 'onni-sale-badge';
                  pdpMedia.appendChild(pdpBadge);
                }
                pdpBadge.textContent = chip2;
              }
            }
            var infoBtn = (!card && setTotal > 0) ? ' <button type="button" class="onni-set-info onni-set-info--inline" aria-haspopup="dialog"><span class="onni-set-info__i" aria-hidden="true">i</span>' + ONNI_PRICEINFO + '</button>' : '';
            // Karten (Paavo 20.07.2026): Grundpreis klein mit in die VIP-Preiszeile ziehen —
            // sonst bleibt er allein in einer eigenen Zeile stehen, weil .price versteckt wird
            // Grundpreis (Paavo 02.10.2026): bezieht sich auf den Code-Preis, nicht auf den
            // Listenpreis (PAngV), und steht auf der PDP in eigener Zeile UNTER dem Preis.
            // Vorher blieb er im versteckten Original-Block stehen und damit ueber dem Preis.
            var unitInline = '', unitRow = '';
            var unitEl = item.querySelector('.unit-price');
            if (unitEl) {
              var unitHtml = onniGrundpreisUmrechnen(unitEl.innerHTML, newpriceNum / oldprice);
              unitEl.style.display = 'none';
              if (card) {
                unitInline = '<small class="unit-price onni-vip-unit">' + unitHtml + '</small>';
              } else {
                unitRow = '<div class="onni-vip-unitrow"><small class="unit-price onni-vip-unit">' + unitHtml + '</small></div>';
              }
            }
            item.outerHTML += '<div class="onni-vip-priceblock"><div class="onni-vip-priceline"><b>'+newprice+' €</b>'+strike+unitInline+infoBtn+'</div>'+unitRow+'<div class="onni-vip-chips">'+chips+'</div></div>';
            var badgeHost = card ? (card.querySelector('.card-gallery') || card.querySelector('.product-card__content') || card) : null;
            var badge = card ? card.querySelector('.onni-sale-badge') : null;
            if (badge && badgeHost && badge.parentElement !== badgeHost) {
              badgeHost.appendChild(badge);
            }
            if (card && !badge) {
              badge = document.createElement('span');
              badge.className = 'onni-sale-badge';
              badge.textContent = chip2;
              badgeHost.appendChild(badge);
            } else if (badge && setTotal > 0) {
              badge.textContent = chip2;
            }
          } else {
            item.getElementsByClassName('price')[0].style.textDecoration = 'line-through';
            item.querySelector('.savings').innerHTML = euroModus ? chip2 : '-' + rabatt.prozent + '%';
            item.outerHTML += '<div style="margin:5px;"><b style="font-size:1.4rem;">'+newprice+' €</b> <br><span class="onni-vip-badge" style="padding: var(--onni-vip-pad-v,3px) var(--onni-vip-pad-h,9px); background: var(--onni-vip-bg,#ffffff); border: var(--onni-vip-border-width,1px) solid var(--onni-vip-border-color,#000000); border-radius: var(--onni-vip-radius,5px); color: var(--onni-vip-fg,#000000); font-size: var(--onni-vip-font-size,18px); display:inline-block;">VIP: '+discount_code+'</span></div>';
          }
  }

  /* Alle Preisstellen eines Typs durchgehen. rabattFuer(item) liefert den Rabatt oder
     null, wenn der aktive Code fuer dieses Produkt nicht gilt.
     Ohne die alte Sekunde Wartezeit (Paavo 02.10.2026): das Skript laeuft defer, die
     Preise stehen dann schon im DOM. Die Wartezeit liess eine Sekunde lang den vollen
     Preis stehen und die Seite springen. Spaeter geladene Karten faengt der Observer. */
  function onniCodePreiseDurchgehen(selektor, rabattFuer) {
    document.querySelectorAll(selektor).forEach(function (item) {
      var rabatt = rabattFuer(item);
      if (!rabatt) { return; }
      // Nachgeladene Karten: schon verarbeitete Container nicht doppelt umbauen
      if (item.getAttribute('data-onni-vip-done')) { return; }
      item.setAttribute('data-onni-vip-done', '1');
      onniCodePreisZeigen(item, rabatt);
    });
    document.documentElement.classList.add('onni-vip-ready');
  }

  // Mix-Codes (discountmix): je Produkt-Kategorie ein eigener Rabatt, es gilt die erste
  // Kategorie aus data-discountmix, fuer die der Code einen Eintrag hat.
  function displayDiscountMix ()  {
    if (!discountmix[discount_code]) { return; }
    var aktiv = discountmix[discount_code].map(function (e) { return e.cat; });
    onniCodePreiseDurchgehen('[data-discountmix]', function (item) {
      var treffer = item.getAttribute('data-discountmix').split(',').filter(function (c) { return aktiv.includes(c); });
      if (!treffer.length) { return null; }
      return ONNI_PREIS.rabatt(discountmix[discount_code].find(function (e) { return e.cat === treffer[0]; }));
    });
  }

  // Normale Codes (discounts): ein Rabatt fuer alle Produkte der Code-Kategorie.
  function displayDiscount ()  {
    var eintrag = applied_discount[discount_code];
    var rabatt = ONNI_PREIS.rabatt(eintrag);
    onniCodePreiseDurchgehen('[data-discount]', function (item) {
      return (onniFlashAktiv() || item.getAttribute('data-discount').split(',').includes(eintrag.cat)) ? rabatt : null;
    });
  }


  // Codes werden ausschliesslich klein geschrieben gepflegt (Paavo 29.07.2026, Shopify + hier
  // einheitlich). Damit alte Links wie onni.de/#Anna20 weiter greifen, wird jeder eingehende
  // Code normalisiert, statt beide Schreibweisen doppelt zu pflegen.
  /* Unser eigenes Cookie zuerst, Shopifys nur als Rueckfallebene: so greifen
     alte Sitzungen weiter, die noch kein `onni_vip_code` haben. */
  let discount_code  = (getCookie(VIP_COOKIE) || getCookie('discount_code') || '').toLowerCase();
  praefixAnmelden(discount_code);

  /* Abgelaufener Code (ONNI_CODE_ENDE): Cookies weg, sonst haengt er bis zu 7 Tage nach. */
  if (discount_code && ONNI_CODE_ENDE[discount_code] && !discounts[discount_code]) {
    document.cookie = VIP_COOKIE + '=; path=/; max-age=0';
    if ((getCookie('discount_code') || '').toLowerCase() === discount_code) { document.cookie = 'discount_code=; path=/; max-age=0'; }
    discount_code = '';
  }

  /* Abgelaufener Code (ONNI_CODE_ENDE): Cookies weg, sonst haengt er bis zu 7 Tage nach. */
  if (discount_code && ONNI_CODE_ENDE[discount_code] && !discounts[discount_code]) {
    document.cookie = VIP_COOKIE + '=; path=/; max-age=0';
    if ((getCookie('discount_code') || '').toLowerCase() === discount_code) { document.cookie = 'discount_code=; path=/; max-age=0'; }
    discount_code = '';
  }

  /* Kam die Kundin ueber Shopifys eigenen Weg herein (`/discount/<code>` oder
     ein Kurzlink darauf), steht der Code nur in Shopifys Cookie. Einmal in
     unseres uebernehmen, sonst ist er nach dem naechsten Checkout weg. */
  if (discount_code && !getCookie(VIP_COOKIE) && (discounts[discount_code] || discountmix[discount_code])) {
    setzeVipCode(discount_code);
  }

  if (location.hash) {
    var hash_code = location.hash.slice(1).toLowerCase();
    praefixAnmelden(hash_code);

    // Nur bekannte Codes uebernehmen. Vorher landete JEDER Hash im Cookie, also auch
    // Anker- und Tracking-Hashes wie #erid90732630 (kommt ueber eine Weiterleitung herein).
    // Ein aktiver VIP-Code wurde dadurch mit Muell ueberschrieben, Badge und Balken
    // verschwanden, und nur Cookies loeschen half.
    if (discounts[hash_code] || discountmix[hash_code]) {
      discount_code = hash_code;

      // path=/ ist zwingend: ohne Pfad nimmt der Browser das Verzeichnis der aktuellen Seite,
      // ein auf /collections/x gesetzter Code galt dann nicht auf /products/y.
      setzeVipCode(discount_code);
    }
  };

  var applied_discount = false;
  if (discounts[discount_code]) {
    applied_discount = discounts;
  } else if (discountmix[discount_code]) {
    applied_discount = discountmix;
  }

  /* Der Platzhalter im <head> kennt die Codeliste nicht und haelt schon bei jedem
     beliebigen Hash Platz vor (#erid90732630 und aehnliches Tracking). Hier ist die
     Liste bekannt: kein gueltiger Code -> Reservierung wieder abraeumen, sonst steht
     ein leerer gruener Balken ueber der Seite. (Ada 05.09.2026) */
  if (applied_discount === false) {
    document.documentElement.classList.remove('onni-has-vipbar');
  }

  if (applied_discount !== false) {

    let template = document.getElementById('discountbar');
    // Flashday: den Balken fuellt assets/onni-flashday.js mit Aktionstext und Countdown.
    // Wuerde hier der VIP-Satz stehen, blitzte er vorher kurz auf.
    if (!onniFlashAktiv()) {
      template.innerHTML = "<a href='https://"+window.location.hostname+"/collections/" + applied_discount[discount_code].cat + "'>DEIN VIP CODE <b><span class='code'>" + discount_code + "</span></b> ist aktiviert!</a>";
      template.style.display = 'block';
    }

    if (document.getElementById('discountmod')) {
      let txt_inline = document.getElementById('discountmod').textContent = applied_discount[discount_code].dis;
    }

    /* ONNI Code-Page v5 (19.07.2026): Platzhalter im VIP-Hero mit echtem Code + Rabatt fuellen.
       .onni-code-slot = Code-Text, .onni-off-slot = Rabatt-Pill (dis in %, fixed in EUR).
       Bei Mix-Codes (discountmix, kein einheitlicher Rabatt) wird die Pill ausgeblendet. */
    document.querySelectorAll('.onni-code-slot').forEach((el) => { el.textContent = onniCodeLabel(discount_code); });
    var off_deal = applied_discount[discount_code];
    var off_txt = '';
    if (off_deal && off_deal.dis) { off_txt = '−' + off_deal.dis + ' %'; }
    else if (off_deal && off_deal.fixed) { off_txt = '−' + off_deal.fixed + ' €'; }
    /* ONNI 06.08.2026 (Paavo): Die Pille zeigt die GESAMTersparnis statt nur des
       Codesatzes, sonst widerspricht der Hero den Kacheln darunter.

       Das Maximum kommt bewusst aus den Kacheln, die der Besucher WIRKLICH SIEHT,
       nicht vom Server. Grund: Bestandskunden werden Nur-Neukunden-Artikel per CSS
       ausgeblendet (html[data-onni-segment='bestand']). Serverseitig gerechnet stand
       oben eine Zahl, deren Produkt sie nie zu Gesicht bekamen.

       Geprueft wird nicht auf die Neukunden-Kennzeichnung, sondern schlicht darauf,
       ob die Kachel gerendert ist (offsetParent). Damit greift es automatisch auch
       beim Sets-Filter und bei allem, was spaeter mal ausgeblendet wird — niemand
       muss daran denken, diese Stelle nachzupflegen.

       Nur bei Prozentcodes: bei einem Fix-Betrag in Euro haengt die Ersparnis am
       Warenkorbwert, ein „bis" waere dort geraten. */
    function onniHeroProzent() {
      if (!off_deal || !off_deal.dis) { return 0; }
      var beste = 0;
      document.querySelectorAll('[data-onni-uvp]').forEach(function (kachel) {
        // offsetParent ist null bei display:none — also genau dann, wenn die
        // Kachel fuer diesen Besucher nicht auf dem Schirm ist.
        if (kachel.offsetParent === null) { return; }
        var preis = parseInt(kachel.getAttribute('data-onni-preis'), 10);
        var uvp = parseInt(kachel.getAttribute('data-onni-uvp'), 10);
        if (!(preis > 0) || !(uvp > preis)) { return; }
        /* Abrunden ueber onniProzentAb, exakt wie die Badges auf den Kacheln.
           Beide Stellen MUESSEN dieselbe Rundung benutzen: als der Hero abrundete
           und die Kachel kaufmaennisch rundete, stand oben „−54 %" und unten
           „−55 %" — derselbe Wert 54,74, nur anders behandelt. */
        var gesamt = ONNI_PREIS.prozent(uvp, ONNI_PREIS.codePreis(preis, {prozent: off_deal.dis}));
        if (gesamt > beste) { beste = gesamt; }
      });
      return beste;
    }

    function onniHeroSchreiben() {
      var text = off_txt;
      var beste = onniHeroProzent();
      if (beste > off_deal.dis) {
        text = (ONNI_IS_EN ? 'UP TO ' : 'BIS ') + '−' + beste + ' %';
      }
      document.querySelectorAll('.onni-off-slot').forEach((el) => {
        if (text) { el.textContent = text; el.style.removeProperty('display'); }
        else { el.style.display = 'none'; }
      });
    }

    document.querySelectorAll('.onni-off-slot').forEach((el) => {
      if (off_txt) { el.textContent = off_txt; } else { el.style.display = 'none'; }
    });
    
    if ( document.querySelector('div.border-style.custom-section-content > div > div > h1') && document.querySelector("div.border-style.custom-section-content div > strong") ) {
      let txt_hero = document.querySelector('div.border-style.custom-section-content > div > div > h1').textContent = 'VIP Code: ' + discount_code;
      let txt_desc = document.querySelector("div.border-style.custom-section-content div > strong").textContent = 'VIP Code: ' + discount_code;
    }

    if (discounts[discount_code]) {
      displayDiscount();
    } else if (discountmix[discount_code]) {
      displayDiscountMix();
    }

    /* Hero-Prozent erst JETZT schreiben: die Kacheln muessen im DOM stehen und die
       Segment-Ausblendung muss gegriffen haben, sonst zaehlt der Browser Kacheln
       mit, die gleich verschwinden. Das Segment setzt onni-kundensegment.liquid
       im <head>, ist hier also schon da; auf das Layout warten wir mit
       requestAnimationFrame, weil offsetParent erst nach dem Stil-Durchlauf stimmt. */
    if (off_deal && off_deal.dis) {
      requestAnimationFrame(function () { onniHeroSchreiben(); });
    }

    // Nachgeladene Karten (Pagination, Filter, Infinite Scroll) nachziehen (19.07.2026):
    // displayDiscount lief bisher nur einmal nach Load, spaeter eingefuegte Karten
    // blieben ohne VIP-Preis. Idempotent dank data-onni-vip-done-Marker.
    var onniVipRerun = null;
    new MutationObserver(function (muts) {
      var relevant = muts.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          if (n.nodeType !== 1) { return false; }
          if (n.matches && n.matches('[data-discount]:not([data-onni-vip-done]), [data-discountmix]:not([data-onni-vip-done])')) { return true; }
          return n.querySelector && !!n.querySelector('[data-discount]:not([data-onni-vip-done]), [data-discountmix]:not([data-onni-vip-done])');
        });
      });
      if (!relevant || onniVipRerun) { return; }
      onniVipRerun = setTimeout(function () {
        onniVipRerun = null;
        if (discounts[discount_code]) { displayDiscount(); } else if (discountmix[discount_code]) { displayDiscountMix(); }
        // Kacheln haben sich geaendert -> das „bis"-Maximum kann jetzt ein anderes sein.
        if (off_deal && off_deal.dis) { onniHeroSchreiben(); }
      }, 250);
    }).observe(document.body, { childList: true, subtree: true });

    // Groessenwechsel ohne Neuladen (02.10.2026): morph tauscht Preise in den
    // bestehenden Knoten aus, statt neue einzufuegen. Der Observer oben sieht das
    // nicht, der VIP-Preis waere bis zum naechsten Seitenaufruf weg. Der
    // Varianten-Snippet meldet sich deshalb nach dem morph selbst.
    document.addEventListener('onni:variant-swapped', function () {
      if (discounts[discount_code]) { displayDiscount(); } else if (discountmix[discount_code]) { displayDiscountMix(); }
    });

  } else {
    /* ONNI: kein gueltiger Code -> vorgehaltenen VIP-Balken-Platz wieder freigeben (kein leerer Balken) */
    document.documentElement.classList.remove('onni-has-vipbar');
  }



  const variant = document.querySelectorAll("variant-radios > fieldset > label");
  if (variant && discounts[discount_code]) {
    variant.forEach((item) => {
      item.addEventListener("click", function(ev){ 
        displayDiscount();
        displayDiscountMix();
      });
    });
  }


  if (window.location.search) {
    setTimeout(() => {
          const h_current = window.location.pathname+window.location.search;
          let elem = document.querySelector('div.menu-list__scroll-container li a[href*="'+h_current+'"]');
          if (elem) {
            elem.classList.add("aria-current");
          }
          
    }, 1000);  
  }


  /* Code-Review C-022 (Johannes 20.10.2026): Mindestbestellwert je Code, Stand Shopify 20.10.2026.
     Nur Abweichungen vom Normalfall 50 EUR. 0 = kein Mindestwert, {stk: n} = ab n Produkten.
     NEUER CODE mit anderem Mindestwert als 50 EUR: hier eintragen, sonst zeigt die Code-Seite 50 EUR. */
  var ONNI_CODE_MIN = {
    'agnes20': 0, 'alex-j20': 0, 'alexa20': 0, 'alexa30': 0, 'anna30': 0, 'annette20': 0,
    'baaam20': 0, 'bday30': 0, 'bday30nl': 0, 'bday30wa': 0, 'birthday2026': 0,
    'birthday2026nl': 0, 'birthday2026nla': 0, 'birthday30': 0, 'boris22': 0, 'claudia-s20': 0,
    'dahoam20': 0, 'danke2025': 0, 'eva20': 0, 'finja22': 0, 'franzi20': 0, 'google18': 0,
    'hannah30': 0, 'healing30': 0, 'isi20': 0, 'jelena20': 0, 'jelena22': 0, 'jelena30': 0,
    'julia20': 0, 'julia22': 0, 'katerina-p20': 0, 'katrin-u20': 0, 'kristin30': 0, 'lilly20': 0,
    'lori20': 0, 'louischen20': 0, 'mama20': 0, 'mara20': 0, 'martina30': 0, 'maxi30': 0,
    'melanie30': 0, 'menina20': 0, 'nastinka20': 0, 'ninabott30': 0, 'ninag20': 0, 'ostern50g': 0,
    'ostern50m': 0, 'ostern50nl': 0, 'ostern50wa': 0, 'patricia20': 0, 'pelican30': 0,
    'pomponetti20': 0, 'profschoettle': 0, 'romina20': 0, 'sara20': 0, 'saskia22': 0, 'save30': 0,
    'savexxl': 0, 'sina20': 0, 'sophi20': 0, 'sophie20': 0, 'sosue20': 0, 'steph20': 0,
    'steph30': 0, 'summer22': 0, 'sunna30': 0, 'susanne20': 0, 'svenja20': 0, 'sweet20': 0,
    'sweetliving20': 0, 'testerset': 0, 'testerset-insta': 0, 'testerset20': 0, 'testersetg': 0,
    'testersetgoogle': 0, 'testersetinsta': 0, 'testersetm': 0, 'tim20': 0, 'tina20': 0,
    'ulrike20': 0, 'valeska30': 0, 'vanessa30': 0, 'vip20': 0, 'xxl99': 0, 'ami22': 40,
    'butik20': 60, 'christin20': 100, 'claudia30': 40, 'iisi30': 40, 'jessica20': 40, 'kera20': 40,
    'lori25': 60, 'love25': 150, 'love26': 150, 'love26wa': 150, 'marie20': 60, 'marlene20': 40,
    'maxi20': 100, 'mothersfinest20': 60, 'nativita30': 40, 'oktoberfest25': 120,
    'onniwiesn25': 60, 'patrizia20': 100, 'sophi30': 40, 'tegernsee20': 40, 'women30nl': 150,
    'women30wa': 150, 'xmas25': 150, 'vip-set-30': {stk: 5}, 'vip-set-40': {stk: 5}, 'vip25': {stk: 3}, 'vip30': {stk: 4},
    'vip40': {stk: 5}, 'yourday30': {stk: 3}
  };
  function onniMindestText() {
    var felder = document.querySelectorAll('[data-onni-mbw]');
    if (!felder.length || !discount_code) { return; }
    var m = Object.prototype.hasOwnProperty.call(ONNI_CODE_MIN, discount_code) ? ONNI_CODE_MIN[discount_code]
      : (discounts[discount_code] && discounts[discount_code].stk) ? {stk: discounts[discount_code].stk} : 50;
    felder.forEach(function (el) {
      var zeile = el.closest('[data-onni-mbw-zeile]') || el;
      if (m === 0) { zeile.hidden = true; return; }
      el.textContent = (m && m.stk) ? ('ab ' + m.stk + ' Produkten') : (m + ' € Mindestbestellwert');
      zeile.hidden = false;
    });
  }
  onniMindestText();

  /* Code-Review 7 (Johannes 20.10.2026): Ein Code aus Link (#women30) oder Cookie senkte bisher nur
     die Preise im Shop, im Warenkorb stand der Vollpreis. Jetzt kommt er auch auf den Warenkorb.
     Regeln:
       - nur bekannte Codes aus dieser Datei, nie der Flash-Code (den verwaltet onni-flashday.js)
       - erst wenn etwas im Warenkorb liegt: kein Warenkorb fuer jeden Besuch, und kein Wettlauf
         mit anderen Skripten beim allerersten Aufruf (zwei Koerbe, siehe onni-bday-sale.liquid)
       - liegt schon ein gueltiger anderer Code an, bleibt er (kein Ueberschreiben, vgl. Nr. 8)
       - einmal je Sitzung und Code */
  var onniCodeWkLaeuft = false;
  function onniCodeInWarenkorb() {
    var code = discount_code;
    if (!code || !(discounts[code] || discountmix[code])) { return; }
    if (window.ONNI_FLASH && code === String(window.ONNI_FLASH.code).toLowerCase()) { return; }
    var merker = 'onni_code_wk_' + code;
    try { if (sessionStorage.getItem(merker)) { return; } } catch (e) {}
    if (onniCodeWkLaeuft) { return; }
    onniCodeWkLaeuft = true;
    function fertig() { try { sessionStorage.setItem(merker, '1'); } catch (e) {} }
    var lesen = typeof window.onniKorb === 'function'
      ? window.onniKorb(true)
      : fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; });
    lesen.then(function (korb) {
      if (!korb || !korb.item_count) { return; }
      var liste = korb.discount_codes || [];
      var schon = liste.some(function (d) { return String(d.code || '').toLowerCase() === code; });
      var fremd = liste.some(function (d) { return d.applicable && String(d.code || '').toLowerCase() !== code; });
      if (schon || fremd) { fertig(); return; }
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code })
      }).then(function (r) { return r.ok ? r.json() : null; }).then(function (neu) {
        if (!neu) { return; }
        fertig();
        // discount:update statt cart:update: der Drawer rendert neu, oeffnet sich aber nicht.
        document.dispatchEvent(new CustomEvent('discount:update', {
          bubbles: true, detail: { resource: neu, sourceId: 'onni-code', data: { source: 'onni-code' } }
        }));
      });
    }).catch(function () {}).then(function () { onniCodeWkLaeuft = false; });
  }
  document.addEventListener('cart:update', function () { setTimeout(onniCodeInWarenkorb, 0); });
  onniCodeInWarenkorb();


  /* ONNI 09.09.2026: kein scrollIntoView. Es zentriert zwar die aktive Kachel
     waagerecht, scrollt aber zusaetzlich die ganze Seite, sobald die Leiste unter
     der Falz liegt (Befund Paavo, Startseite iPhone: Sprung auf scrollY 500).
     Nur den waagerechten Container schieben. */
  const scrollm = document.querySelector('a.menu-list__item[aria-current]');
  if (scrollm && document.documentElement.clientWidth < 750) {
    const box = scrollm.closest('.menu-list__scroll-container') || scrollm.parentElement;
    if (box) {
      const c = box.getBoundingClientRect();
      const z = scrollm.getBoundingClientRect();
      const versatz = (z.left - c.left) - (c.width - z.width) / 2;
      box.scrollTo({ left: box.scrollLeft + versatz, behavior: "smooth" });
    }
  }

  
  // 20.07.2026 Paavo: Filter-Button auf Mobile IMMER sichtbar (vorher erst ab 100px Scroll
  // eingeblendet -> wirkte auf der Collection wie "kein Filter vorhanden").


})();
